import React from 'react'

import { useOOGlobals } from '../OOGlobalsProvider/OOGlobalsProvider'
import { useOutpost } from '../OutpostProvider/OutpostProvider'
import { Notification } from '../Notification/Notification'

import namespacedStorage from '../../utils/namespaced-storage'

import './WelcomeMessage.css'

const welcomeMessageStorage = namespacedStorage('OOWelcomeMessage')
const welcomeMessageViewedKey = 'viewed'

export const welcomeMessageText = 'We updated our look! We hope you enjoy the improvements we made.'

export const WelcomeMessage = () => {
  const { spaPreviousVersion } = useOOGlobals()
  const { isOutpost } = useOutpost()

  if (isOutpost || !(spaPreviousVersion === 'V2') || welcomeMessageStorage.get(welcomeMessageViewedKey)) {
    return null
  }

  const setViewed = () => {
    welcomeMessageStorage.set(welcomeMessageViewedKey, true)
  }

  return (
    <Notification padTop isCloseable onClose={setViewed}>
      <div styleName='body'>
        {welcomeMessageText}
      </div>
    </Notification>
  )
}
